var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConferenceRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RoomType/Medium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone-Booth-Availability",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PhoneBoothAvailability_Open_D",
    transform: "translate(-1210.000000, -327.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1200.000000, 317.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RoomType/Medium",
    transform: "translate(10.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FEDE73",
    x: 3.27761368,
    y: 2.94335633,
    width: 10.9565217,
    height: 8.32198142,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3929344,7.65753275 C14.2903127,7.75953366 15.1414052,6.93539479 15.1083175,5.89572145 C15.0752297,4.8560481 14.3503964,4.13534166 13.3929344,4.20297856 C13.3789162,4.20396883 13.3888259,5.05830565 13.3929344,5.93025566 C13.3969638,6.78541958 13.3929344,7.65753275 13.3929344,7.65753275 Z",
    id: "Oval-Copy-10",
    stroke: "#000000",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600516515,7.67765423 C1.49789483,7.77965514 2.34898734,6.95551627 2.31589961,5.91584292 C2.28281187,4.87616957 1.55797852,4.15546314 0.600516515,4.22310003 C0.586498363,4.2240903 0.596408059,5.07842712 0.600516515,5.95037713 C0.604545879,6.80554106 0.600516515,7.67765423 0.600516515,7.67765423 Z",
    id: "Oval-Copy-13",
    stroke: "#000000",
    strokeWidth: 0.6,
    transform: "translate(1.455051, 5.952456) rotate(-180.000000) translate(-1.455051, -5.952456) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30402586,12.3744221 C10.3264259,12.4639501 11.2960917,11.7405891 11.2583942,10.8280497 C11.2206967,9.91551033 10.3948804,9.28293375 9.30402586,9.34229983 C9.28805471,9.34316901 9.29934502,10.0930353 9.30402586,10.858361 C9.30861659,11.6089532 9.30402586,12.3744221 9.30402586,12.3744221 Z",
    id: "Oval-Copy-11",
    stroke: "#000000",
    strokeWidth: 0.6,
    transform: "translate(10.277614, 10.860186) rotate(-270.000000) translate(-10.277614, -10.860186) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43446064,12.3744221 C5.4568607,12.4639501 6.42652648,11.7405891 6.38882899,10.8280497 C6.35113151,9.91551033 5.52531519,9.28293375 4.43446064,9.34229983 C4.4184895,9.34316901 4.4297798,10.0930353 4.43446064,10.858361 C4.43905137,11.6089532 4.43446064,12.3744221 4.43446064,12.3744221 Z",
    id: "Oval-Copy-12",
    stroke: "#000000",
    strokeWidth: 0.6,
    transform: "translate(5.408048, 10.860186) rotate(-270.000000) translate(-5.408048, -10.860186) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43446064,2.55448405 C5.4568607,2.64401202 6.42652648,1.920651 6.38882899,1.00811162 C6.35113151,0.0955722447 5.52531519,-0.53700433 4.43446064,-0.47763825 C4.4184895,-0.476769074 4.4297798,0.273097212 4.43446064,1.0384229 C4.43905137,1.78901515 4.43446064,2.55448405 4.43446064,2.55448405 Z",
    id: "Oval-Copy-18",
    stroke: "#000000",
    strokeWidth: 0.6,
    transform: "translate(5.408048, 1.040248) rotate(-90.000000) translate(-5.408048, -1.040248) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30402586,2.55448405 C10.3264259,2.64401202 11.2960917,1.920651 11.2583942,1.00811162 C11.2206967,0.0955722447 10.3948804,-0.53700433 9.30402586,-0.47763825 C9.28805471,-0.476769074 9.29934502,0.273097212 9.30402586,1.0384229 C9.30861659,1.78901515 9.30402586,2.55448405 9.30402586,2.55448405 Z",
    id: "Oval-Copy-19",
    stroke: "#000000",
    strokeWidth: 0.6,
    transform: "translate(10.277614, 1.040248) rotate(-90.000000) translate(-10.277614, -1.040248) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#000000",
    strokeWidth: 0.6,
    x: 2.36022237,
    y: 2.06852169,
    width: 10.9652174,
    height: 7.72198142,
    rx: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConferenceRoom);
export default __webpack_public_path__ + "static/media/ConferenceRoom.b1b19c0f8c14a2b97af59f38ffefea42.svg";
export { ForwardRef as ReactComponent };